import React from 'react';
import { HeaderLogo } from './HeaderLogo';
import { HeaderDesktopMenu } from './HeaderDesktopMenu';
import { HeaderDesktopUtility } from './HeaderDesktopUtility';
import { HeaderMobileActions } from './HeaderMobileActions';
import { HeaderMobileNav } from './HeaderMobileNav';
export function Header() {
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-id="element-2670">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2671">
        <div className="relative flex items-center justify-between h-20" data-id="element-2672">
          <HeaderLogo data-id="element-2673" />
          <HeaderDesktopMenu data-id="element-2674" />
          <HeaderDesktopUtility data-id="element-2675" />
          <HeaderMobileActions data-id="element-2676" />
          <HeaderMobileNav data-id="element-2677" />
        </div>
      </div>
    </header>;
}